export default __webpack_public_path__ + "static/media/mapFrameBlack.0c79fa8c.png";